export default __webpack_public_path__ + "static/media/Logo-admin.c6a51eff.png";